<template>
	<!-- 导航栏 -->
	<div>
		<el-dialog :title="$t('navbar.inhint')" :visible.sync="centerDialogVisible" width="30%" center>
			<center>
				<span>
					<p><img src="../img/miner-address.png" /></p>
					<el-autocomplete id="wallet_address" style="width: 75%;" prefix-icon="el-icon-wallet"
						class="inline-input" v-model="state2" :fetch-suggestions="querySearch" placeholder="请输入钱包地址"
						@select="handleSelect">
						<!-- :trigger-on-focus="false" -->
						<el-button slot="append" style="background-color: #409EFF; color: white;font-size: 1rem;"
							@click="query()">{{$t('navbar.quertButton')}}</el-button>
					</el-autocomplete>
				</span>
			</center>
			<!-- <span slot="footer" class="dialog-footer">
	    <el-button @click="centerDialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
	  </span> -->
		</el-dialog>
<el-dialog
	  title="提示"
	  :visible.sync="tip2"
	  width="30%"
	  :close-on-click-modal="false"
	  :close-on-press-escape="false"
	  :show-close="false"
	  center>
	  <span>本人在此确认并申明：本人非古巴、伊朗、朝鲜、叙利亚以及其他受到相关国家或政府或国际机构管理或执行的制裁的国家或地区居民。StarMap提供的矿池服务在本人所在的国家或地区是符合法律法规和相关政策的。</span>
	  
	  <br><el-checkbox style="width: 100%;" v-model="checked">由于本人所在的国家或地区使用StarMap提供的服务系违法导致的所有法律风险和责任将完全由本人独立承担。</el-checkbox>
      
    
	  <span slot="footer" class="dialog-footer">
	   
	    <el-button type="primary" @click="confiremtip" >确 定</el-button>
	  </span>
	</el-dialog>


		<at-menu theme='dark' mode='horizontal' active-name="1">
			<at-menu-item name="0" style="height: 45px;" to='/'><img class="logo" src="../img/logo.png"  height="40px" style="margin-top: 2.5px;"></at-menu-item>
			<at-menu-item name="5" to='/'><i class="icon icon-home"></i>{{$t('navbar.home')}}</at-menu-item>
			<at-submenu>
				<template slot="title"><i class="icon icon-life-buoy"></i>{{$t('navbar.pool')}}</template>
				<at-menu-item name="1-1" to='/block'>{{$t('navbar.blockinfo')}}</at-menu-item>
				<at-menu-item name="1-2" to='/payments'>{{$t('navbar.paymenthistory')}}</at-menu-item>
				<!-- 			<at-menu-item name="1-3" to='/calc'>{{$t('navbar.calc')}}</at-menu-item>
			<at-menu-item name="1-4" to="/create">{{$t('navbar.autominer')}}</at-menu-item> -->
			</at-submenu>
			<at-menu-item name="6" to='/calc'>
				<!-- 	<i class="icon icon-home"></i> -->
				<template>
					<font-awesome-icon :icon="['fa', 'calculator']"></font-awesome-icon>&nbsp;
					{{$t('navbar.calc')}}
				</template>
			</at-menu-item>
			
			<at-menu-item name="7" to='/create'><i class="icon icon-battery-charging"></i>{{$t('navbar.autominer')}}
			</at-menu-item>
			<at-menu-item v-if="lang.l==='zh'" name="11" @click.native="toChat()"><i
					class="el-icon-s-comment"></i>{{$t('navbar.chat')}}</at-menu-item>
			<at-submenu>
				<template slot="title"><i class="icon icon-command"></i>{{$t('navbar.cxq')}}</template>
				<at-menu-item name="8-1" to="/labs/eth-index">ETH</at-menu-item>
				<at-menu-item name="8-1" to="/labs/etc-index">ETC</at-menu-item>
				<!-- 			<at-menu-item name="2-2">功能待发布</at-menu-item>
			<at-menu-item name="2-3">功能待发布</at-menu-item>
			<at-menu-item name="2-4">功能待发布</at-menu-item> -->
			</at-submenu>

			<!-- <at-submenu>
			<template slot="title"><i class="icon icon-command"></i>交易</template>
			<at-menu-item name="2-1">功能待发布</at-menu-item>
			<at-menu-item name="2-2">功能待发布</at-menu-item>
			<at-menu-item name="2-3">功能待发布</at-menu-item>
			<at-menu-item name="2-4">功能待发布</at-menu-item>
		</at-submenu> -->
			<at-submenu style="float:right;">
				<template slot="title">
					<font-awesome-icon :icon="['fa', 'globe']"></font-awesome-icon>&nbsp;&nbsp;
					<span v-if="lang.l==='hk'">繁體中文</span>
					<span v-else-if="lang.l==='zh'">简体中文</span>
					
					<span v-else-if="lang.l==='en'">English</span>
				</template>
				<at-menu-item name="3-1" @click.native="changelang('zh')">简体中文</at-menu-item>
				<at-menu-item name="3-1" @click.native="changelang('hk')">繁體中文</at-menu-item>
				<at-menu-item name="3-2" @click.native="changelang('en')">English</at-menu-item>
			</at-submenu>
			<at-menu-item name="4" style="float:right;" @click.native="centerDialogVisible = true">
				<font-awesome-icon :icon="['fa', 'user-circle']"></font-awesome-icon>&nbsp;&nbsp;
				{{$t('navbar.mineraddress')}}
			</at-menu-item>

			<at-menu-item name="5" style="float:right;" to="/login?redirect=/labs/eth-index" v-if="islogined===false">
				<font-awesome-icon :icon="['fa', 'user-circle']"></font-awesome-icon>&nbsp;&nbsp; {{$t('navbar.login')}}
			</at-menu-item>
			<at-submenu style="float:right;" v-if="islogined===true">
				<template slot="title" style="width: 9.375rem;">
					<font-awesome-icon :icon="['fa', 'user-circle']"></font-awesome-icon>&nbsp;&nbsp; {{username}}
				</template>
				<at-menu-item name="6-1" to="/labs/user">{{$t('navbar2.usercenter')}}</at-menu-item>
				<at-menu-item name="6-2" @click.native="logout()">退出登录</at-menu-item>
			</at-submenu>
		</at-menu>
	</div>
	

	
</template>

<script>
	import Vue from 'vue'
	var axios = require('axios');
	var qs = require('qs');
	export default {
		data() {
			return {
				checked:false,
				tip2:true,
				centerDialogVisible: false,
				restaurants: [],
				url: this.$global.url,
				state2: '',
				lang: {
					l: localStorage.getItem('locale') || 'hk'
				},
				islogined: false,
				username: null
			}
		},
		created() {
			this.verifyToken()
			if(localStorage.getItem('isreadtip')==='true'){
				
				this.tip2=false
			}
		},
		mounted() {
			
			window.onresize = () => {
				this.page_width();
			};
			this.page_width();
			this.restaurants = this.loadAll();
			//console.log(localStorage.getItem('isreadtip'))
			
		},
		methods: {
			confiremtip(){
				if(this.checked===true){
					this.tip2=false
					window.localStorage.setItem("isreadtip",true)
					
				}else{
					
				}
			},
			page_width() {
				let screenWidth = window.screen.width;
				console.log(screenWidth);
				if (screenWidth < 800) {
					this.fullWidth = false;
				} else {
					this.fullWidth = true;
				}
			},
			toChat() {
				window.open("https://chat.c3pool.com")
			},
			logout() {
				localStorage.removeItem("token");
				this.islogined = false
				this.$router.push({
					path: "/"
				});
			},
			verifyToken() {
				let that = this
				var data = qs.stringify({
					'token': localStorage.getItem('token')
				});
				var config = {
					method: 'post',
					url: this.url + '/api/verifyToken',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					data: data
				};

				axios(config)
					.then(function(res) {
						if (res.data.code === 0) {
							// this.$message.success(res.data.msg)
							// this.activeName = "login";
							that.islogined = true
							that.username = res.data.data.username
						} else {
							that.islogined = false
							console.log(that.$route.path)
							if (that.$route.path === "/" || that.$route.path === "/miner" || that.$route.path ===
								"/block" || that.$route.path === "/payments" || that.$route.path === "/calc" || that
								.$route.path === "/help" || that.$route.path === "/about" || that.$route.path ===
								"/create"|| that.$route.path ==="/observer") {

							} else {
								that.$message.warning("登陆失效，请重新登陆")
								that.$router.push({
									path: "/login?redirect=/labs/eth-index"// + that.$route.path.replace("/", "")
								});
							}

						}
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			changelang(langs) {
				if (langs === 'zh') {

					Vue.set(this.lang, 'l', 'zh')
				} else if (langs === 'en') {

					Vue.set(this.lang, 'l', 'en')
				}

				this.$i18n.locale = langs;
				window.localStorage.setItem('locale', langs)
				location.reload()

			},
			query() {
				let wallet = this.state2
				if (/^[4|8]{1}([A-Za-z0-9]{105}|[A-Za-z0-9]{94})$/.test(wallet)) {
					this.$router.push({
						path: '/miner?address=' + wallet
					})
				} else {
					this.$notify.error({
						title: this.$t('navbar.error'),
						message: this.$t('navbar.ica')
					});
				}
			},
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return restaurant => {
					return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
				};
			},
			loadAll() {
				var add = localStorage.getItem('address');
				if (add === null) {
					add = [];
				} else {
					add = JSON.parse(add);
				}

				return add;
			},
			handleSelect(item) {
				// console.log(item);
			},
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			open() {
				this.$prompt(this.$t('navbar.inhint'), this.$t('navbar.inhinttitle'), {
					confirmButtonText: this.$t('navbar.confirm'),
					cancelButtonText: this.$t('navbar.cancel'),
					inputPattern: /^[4|8]{1}([A-Za-z0-9]{105}|[A-Za-z0-9]{94})$/,
					inputErrorMessage: this.$t('navbar.iem')
				}).then(({
					value
				}) => {
					this.$router.push({
						path: '/miner?address=' + value
					})
					// this.$message({
					// 	type: 'success',
					// 	message: '你的钱包是: ' + value
					// });
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '取消输入'
					// });
				});
			},
			open() {

			}
		}
	}
</script>

<style>
	.at-menu__item-link {
		height: 45px;
	}
	 .el-checkbox__label {
	  display: inline-grid;
	  width:90%;
	  white-space: pre-line;
	  word-wrap: break-word;
	  line-height: 20px;
	}

	.logo{
 
		    image-rendering: -moz-crisp-edges; /* Firefox */
		    image-rendering: -o-crisp-edges; /* Opera */
		    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
		    image-rendering: crisp-edges;    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */

	}
</style>
